import type { PaletteOptions } from '@mui/material';
import { blue, grey } from '@mui/material/colors';

export const palette: PaletteOptions = {
  mode: 'dark',
  primary: grey,
  secondary: blue,
};
